import * as Sentry from "@sentry/react";
import { isEnv } from "./_config";

class Logger {
	static dir() {
		if (!isEnv("prod")) {
			console.dir(...arguments);
		}
	}

	static log() {
		if (!isEnv("prod")) {
			console.log(...arguments);
		}
	}

	static info() {
		if (!isEnv("prod")) {
			console.info(...arguments);
		}
	}

	static warn() {
		if (!isEnv("prod")) {
			console.warn(...arguments);
		}
	}

	static error() {
		if (!isEnv("prod")) {
			console.error(...arguments);
		}
	}

	static critical() {
		Sentry.captureException(new Error(JSON.stringify(...arguments)));
		console.error(...arguments);
	}

	static trace() {
		if (!isEnv("prod")) {
			console.trace(...arguments);
		}
	}
}

export default Logger;
export const dir = Logger.dir;
export const log = Logger.log;
export const info = Logger.info;
export const warn = Logger.warn;
export const error = Logger.error;
export const trace = Logger.trace;
export const critical = Logger.critical;
